/* TODO: translate */

import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-autocomplete',
    'hint',
    'Используйте стрелки вверх и вниз для просмотра и Enter для выбора.'
);
Labels.set('ui-autocomplete', 'suggestions', 'Подсказки');
Labels.set('ui-autocomplete', 'suggestionsFound', 'Подсказки показаны: ');
Labels.set('ui-autocomplete', 'noSuggestionsFound', 'Подсказок нет');
